@if (initialized && dto) {
    @if (uiMode == 'side' || uiMode == 'mini-side') {
        <hg-import-object-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)">
        </hg-import-object-side>
    } @else {
        <hg-import-object-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)">
        </hg-import-object-full>
    }
}
